import React from 'react';
import { strings } from 'src/localization';
import css from './ToastBar.module.scss';
import { IconCheckMark } from 'src/content/icons';
import { SpecData } from 'src/models';

export interface IProps {
    type?: string;
    message: string;
    specialMsg?: string;
    specData?: SpecData;
    theme?: string;
}

const ToastBar = (props: IProps) => {
    let header = strings.ApptSelected;
    let toastClass = css.toastDiv;
    if (props.type === 'Service') {
        header = strings.ServiceAdded;
    }
    if (props.type === 'Recall') {
        header = strings.ServiceAdded;
        if (props.specData?.recallMsg) {
            header = props.specData?.recallMsg;
        }
        toastClass = css.toastDivRecall;
    }
    if (props.type === 'RestrRecall') {
        if (props.specialMsg) {
            header = props.specialMsg;
        }
        toastClass = css.toastDivRecall;
    }

    let toastH2Class = css.toastH2;
    let toastH3Class = css.toasth3;
    let iconBorderClass = css.iconBorder;
    let mainDivClass = css.mainDiv;
    if (props.theme === 'ford') {
        toastH2Class = css.fordToastH2;
        toastH3Class = css.fordToastH3;
        iconBorderClass = css.fordIconBorder;
        mainDivClass = css.fordMainDiv;
    }

    const message = props.message;

    return (
        <div className={mainDivClass}>
            <div className={iconBorderClass}>
                <IconCheckMark
                    style={{
                        height: '3.5rem',
                        width: '3.5rem',
                        margin: '-.5rem .5rem 0.5rem',
                    }} />
            </div>

            <div className={toastClass}>
                <h2 id='headerMsg' className={toastH2Class}>{header}</h2>
                <h3 className={toastH3Class}>{message}</h3>
            </div>
        </div>
    );
};

export default ToastBar;